import { useParameters } from './use-parameters'
import { useTrackingWrapper } from './use-tracking-wrapper'

export const useTrackingParameters = () => {
  const parameters = useParameters()
  const wrapper = useTrackingWrapper()
  wrapper?.setTcVar('parameters', parameters)
}
